import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
interface ModalSuccessProps {
  title: string;
  subtitle?: string;
}
export function ModalSuccess({
  title,
  subtitle
}: ModalSuccessProps) {
  return <motion.div key="success" initial={{
    opacity: 0,
    scale: 0.96
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.2,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex flex-col items-center justify-center py-14" role="status" data-id="element-1422" data-mp="20irsvazgi0xt">
      <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4" data-id="element-1423" data-mp="1vl83bexb61qk">
        <CheckCircle2 className="w-10 h-10 text-green-500" data-id="element-1424" data-mp="1hlgwpz94fnml" />
      </div>
      <p className="text-lg font-semibold text-slate-800" data-id="element-1425" data-mp="1llqy0ylyxpv4">{title}</p>
      {subtitle && <p className="text-sm text-slate-500 mt-1" data-id="element-1426" data-mp="1lntxsacxaxd1">{subtitle}</p>}
    </motion.div>;
}